import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ClipboardModule } from 'ngx-clipboard';
import {
  NgbDatepickerModule,
  NgbDropdownModule,
  NgbModalModule,
  NgbPaginationModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';

import { SpinnerComponent } from './controls/spinner/spinner.component';
import { MessageComponent } from './controls/message/message.component';
import { TimeLapsComponent } from './controls/time-laps/time-laps.component';
import { ModalDialogComponent } from './controls/modal-dialog/modal-dialog.component';
import { AlertComponent } from '@common/controls/alert/alert.component';

import { LoggingService } from './services/utility/logging.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavigationService } from './services/utility/navigation.service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CallTimePipe } from '@specialist/common/pipes';
import { FeatureSupportDirective } from '@common/directives/feature-support.directive';
import {
  IntersectionObserverDirective,
  IntersectionObserverGroupDirective,
} from '@common/directives/intersection-observer.directive';
import { InputDigitMaskDirective } from '@common/directives/input-digit-mask.directive';
import { CopyMemberNumberComponent } from '@common/components/copy-member-number/copy-member-number.component';
import { RatingInputComponent } from '@common/components/rating-input/rating-input.component';
import { WINDOW_PROVIDERS } from '@common/services/ui/window.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { TextFieldModule } from '@angular/cdk/text-field';
import { IconSpriteModule } from 'ng-svg-icon-sprite';
import { environment } from '@env/environment';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DateRangeComponent } from './controls/date-range/date-range.component';
import { VersionService } from './services/utility/version.service';
import { ContactcCenterMwHeraldService } from './services/utility/contactcentermwherald.service';
import { SessionDataService } from './services/session/session-data.service';
import { SafeHtmlPipe } from '@specialist/common/pipes/safe-html.pipe';
import { ShadowDomComponent } from '@common/components/shadow-dom/shadow-dom.component';
import { DateAsAgoPipe } from '@specialist/common/pipes/date-as-ago.pipe';

@NgModule({
  declarations: [
    SpinnerComponent,
    MessageComponent,
    AlertComponent,
    TimeLapsComponent,
    ModalDialogComponent,
    CallTimePipe,
    FeatureSupportDirective,
    IntersectionObserverDirective,
    IntersectionObserverGroupDirective,
    InputDigitMaskDirective,
    CopyMemberNumberComponent,
    RatingInputComponent,
    DateRangeComponent,
    SafeHtmlPipe,
    ShadowDomComponent,
    DateAsAgoPipe,
  ],
  imports: [
    CommonModule,
    ClipboardModule,
    FormsModule,
    ReactiveFormsModule,
    NgbPaginationModule,
    NgbModalModule,
    NgbTooltipModule,
    InfiniteScrollModule,
    NgSelectModule,
    IconSpriteModule.forRoot({ path: environment.spritePath }),
    DragDropModule,
    NgbDatepickerModule,
    NgbDropdownModule,
  ],
  exports: [
    CommonModule,
    SpinnerComponent,
    MessageComponent,
    AlertComponent,
    TimeLapsComponent,
    ModalDialogComponent,
    ClipboardModule,
    FormsModule,
    ReactiveFormsModule,
    NgbPaginationModule,
    NgbModalModule,
    NgbTooltipModule,
    InfiniteScrollModule,
    NgSelectModule,
    CallTimePipe,
    FeatureSupportDirective,
    IntersectionObserverDirective,
    IntersectionObserverGroupDirective,
    InputDigitMaskDirective,
    CopyMemberNumberComponent,
    RatingInputComponent,
    TextFieldModule,
    IconSpriteModule,
    DragDropModule,
    DateRangeComponent,
    SafeHtmlPipe,
    ShadowDomComponent,
    DateAsAgoPipe,
  ],
  providers: [
    LoggingService,
    NavigationService,
    DatePipe,
    VersionService,
    ContactcCenterMwHeraldService,
    SessionDataService,
    WINDOW_PROVIDERS,
  ],
})
export class CommonLibModule {}
